module.exports = __webpack_public_path__ + "1b4e0948deca3e7e38c0d23a27c36fe3.svg";